<template>
    <section id="booking">

<div class="container">
  <div class="row align-items-center">
    <div class="col-lg-6">
      <div class="mb-4 text-start">
        <h5 class="text-secondary">Easy and Fast </h5>
        <h3 class="fs-xl-10 fs-lg-8 fs-7 fw-bold font-cursive text-capitalize">Book your next trip in 3 easy steps</h3>
      </div>
      <div class="d-flex align-items-start mb-5">
        <div class="bg-primary me-sm-4 me-3 p-3" style="border-radius: 13px"> <img src="../../assets/img/steps/selection.svg" width="22" alt="steps" /></div>
        <div class="flex-1">
          <h5 class="text-secondary fw-bold fs-0">Choose Destination</h5>
          <p>Choose your favourite place. No matter <br class="d-none d-sm-block"> where you travel inside the World.</p>
        </div>
      </div>
      <div class="d-flex align-items-start mb-5">
        <div class="bg-danger me-sm-4 me-3 p-3" style="border-radius: 13px"> <img src="../../assets/img/steps/water-sport.svg" width="22" alt="steps" /></div>
        <div class="flex-1">
          <h5 class="text-secondary fw-bold fs-0">Make Payment</h5>
          <p>After find your perfect spot, make your <br class="d-none d-sm-block"> payment and get ready to travel.</p>
        </div>
      </div>
      <div class="d-flex align-items-start mb-5">
        <div class="bg-info me-sm-4 me-3 p-3" style="border-radius: 13px"> <img src="../../assets/img/steps/taxi.svg" width="22" alt="steps" /></div>
        <div class="flex-1">
          <h5 class="text-secondary fw-bold fs-0">Reach Airport on Selected Date</h5>
          <p>Lastly, you have to arrive at the airport <br class="d-none d-sm-block"> on time and enjoy the vacation.</p>
        </div>
      </div>
    </div>
   
  </div>
</div><!-- end of .container-->

</section>
</template>

<script>
export default {
 name : 'UserFav'
}
</script>

<style>

</style>